import { cn } from "@nexus/ui"

export function MetricTile({
  value,
  label,
  muted = false,
  valueClassName,
}: {
  value: string
  label: string
  muted?: boolean
  valueClassName?: string
}) {
  return (
    <div
      className={cn(
        "flex flex-col gap-0.5 rounded-lg border border-border/55 bg-muted/35 px-[11px] py-[7px]",
        muted && "opacity-60",
      )}
    >
      <span
        className={cn(
          "font-mono text-[15px] font-medium leading-none tracking-[-0.02em] text-foreground",
          valueClassName,
        )}
      >
        {value}
      </span>
      <span className="text-[10px] text-muted-foreground">{label}</span>
    </div>
  )
}
